import {
  CellProps,
  ControlProps,
  getControlPath,
  isStringControl,
  RankedTester,
  rankWith,
  WithClassname,
} from "@jsonforms/core";
import { useJsonForms, withJsonFormsCellProps } from "@jsonforms/react";
import { WithOptionLabel } from "@jsonforms/material-renderers";
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

export const MaterialTextCell = (
  props: CellProps &
    Partial<ControlProps> &
    Partial<WithClassname> &
    Partial<WithOptionLabel>,
) => {
  const { core } = useJsonForms();
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const errors = core?.errors?.filter(e => getControlPath(e) === props.path);
    const hasErrors =
      core?.validationMode === "ValidateAndShow" && errors && errors.length > 0;
    setIsValid(!hasErrors);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [core?.errors]);

  return (
    <TextField
      {...props}
      error={!isValid}
      label={props.schema.title}
      variant="outlined"
      value={props.data}
      disabled={!props.enabled}
      onChange={ev => props.handleChange(props.path, ev.currentTarget.value)}
    />
  );
};

export const materialTextCellTester: RankedTester = rankWith(
  10,
  isStringControl,
);

export default withJsonFormsCellProps(MaterialTextCell);
